var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarMonth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "18px",
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9B4B0251-8363-496E-B41A-87AC5FA05042") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-372.000000, -4878.000000)",
    fill: "#464646",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.75,4878 C394.716498,4878 395.5,4878.7835 395.5,4879.75 L395.5,4879.75 L395.5,4893.75 C395.5,4894.7165 394.716498,4895.5 393.75,4895.5 L393.75,4895.5 L373.75,4895.5 C372.783502,4895.5 372,4894.7165 372,4893.75 L372,4893.75 L372,4879.75 C372,4878.7835 372.783502,4878 373.75,4878 L373.75,4878 Z M373.500237,4887.5005 L373.5,4893.75 C373.5,4893.88807 373.611929,4894 373.75,4894 L373.75,4894 L379.37,4894 L379.37,4887.509 L373.63,4887.51 C373.585913,4887.51 373.542584,4887.50676 373.500237,4887.5005 Z M386.37,4887.509 L381.13,4887.509 L381.13,4894 L386.37,4894 L386.37,4887.509 Z M394,4887.509 L388.13,4887.509 L388.13,4894 L393.75,4894 C393.868347,4894 393.967487,4893.91777 393.993397,4893.80732 L394,4893.75 L394,4887.509 Z M379.37,4879.5 L373.75,4879.5 C373.611929,4879.5 373.5,4879.61193 373.5,4879.75 L373.5,4879.75 L373.500237,4885.7595 C373.542584,4885.75324 373.585913,4885.75 373.63,4885.75 L379.37,4885.749 L379.37,4879.5 Z M386.37,4879.5 L381.13,4879.5 L381.13,4885.749 L386.37,4885.749 L386.37,4879.5 Z M393.75,4879.5 L388.13,4879.5 L388.13,4885.749 L394,4885.749 L394,4879.75 C394,4879.63165 393.917767,4879.53251 393.807323,4879.5066 L393.75,4879.5 Z",
    id: "Month"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMonth);
export default __webpack_public_path__ + "static/media/CalendarMonth.50dd87b31617294cda6bb433d9d01b93.svg";
export { ForwardRef as ReactComponent };